import { PermissionDTO } from './permissions.contracts';

/**
 * Name of the seeded administrator role (see api migration AddRoleIsSystemAndIsReadOnlyColumns).
 *
 * Matched by name rather than by the `isSystem` flag: `user` and `viewer` are seeded and
 * flagged too, so isSystem means "cannot be deleted", not "is an administrator".
 */
export const APPLICATION_ADMIN_ROLE_NAME = 'application_admin';

export interface RoleDTO {
  id: number;
  name: string;
  description: string;
  isSystem: boolean;
  isReadOnly: boolean;
  permissions: PermissionDTO[];
}
